
        require('./index.scss');
        'use strict';

/*
 * @Author: finian
 * @Date: 2021-03-01 10:32:47
 * @LastEditors: your name
 * @LastEditTime: 2021-03-01 15:48:54
 */
var $ = window.$;
var $mod = $('.pc-ie-hack');
var DEFAULT_VERSION = 8.0;
var ua = navigator.userAgent.toLowerCase();
var isIE = ua.indexOf('msie') > -1;
var safariVersion;
if (isIE) {
    safariVersion = ua.match(/msie ([\d.]+)/)[1];
}
if (safariVersion <= DEFAULT_VERSION) {
    $mod.show();
};;
    


// WEBPACK FOOTER //
// ./src/module/ie-hack/index.js